import { Chip } from '@mui/material';
import { statusChipColors } from '../../theme';

function normalizeStatusKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
}

export default function StatusChip({ status, label, size = 'small', sx, ...rest }) {
  const key = normalizeStatusKey(status);
  const palette = statusChipColors[key] || statusChipColors.default;
  const text = label != null ? label : String(status || '—');

  return (
    <Chip
      size={size}
      label={text}
      sx={{
        bgcolor: palette.bg,
        color: palette.color,
        border: `1px solid ${palette.border}`,
        fontWeight: 600,
        height: 26,
        ...sx
      }}
      {...rest}
    />
  );
}
